

    <header class="section-header" *ngIf="router.url !== '/login' && router.url !=='/registration'">
        <section class="header-main shadow-sm bg-primary-style2">
        <div class="container">
        <div class="row align-items-center">
        <div class="col-1">
        <a href="home.html" class="brand-wrap mb-0">
          
        <img   id="imgLogo" name="imgLogo" class="img-fluid logo-size" />
        </a>
       
        </div>
        <div class="col-3 d-flex align-items-center">
        <div class="dropdown mr-3">
        <a class="btn-border-1 text-white d-flex align-items-center py-3"  href="javascript:void(0);"  id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <div><i class="feather-map-pin mr-2 primary-dark rounded-pill p-2 ico font-size"></i></div>
        <div>
        <!-- <p class="text-white mb-0 small">Select Location </p> -->
      {{selectedBranchName}}

      <p *ngIf="(+storeSettings.noOfBranches)>1" (click)="locationChange()" class="text-white mb-0 small cursor-pointer" style="text-decoration: underline; cursor: pointer;">Change </p>
        </div>
        </a>
        <!-- <div class="dropdown-menu p-0 drop-loc" aria-labelledby="navbarDropdown">
        <div >
        <div class="search_location bg-primary p-3 text-right">
        <div class="input-group rounded shadow-sm overflow-hidden">
        <div class="input-group-prepend">
        <button class="border-0 btn btn-outline-secondary text-dark bg-white btn-block"><i class="feather-search"></i></button>
        </div>
        <input type="text" class="shadow-none border-0 form-control" placeholder="Enter Your Location" />
        </div>
        </div>
        <div class="p-3 border-bottom">
        <a href="javascript:void(0);"  class="text-decoration-none">
        <p class="font-weight-bold text-primary m-0"><i class="feather-navigation"></i>{{selectedBranchName}} </p>
        </a>
        </div>
        <div class="filter">
        
       
        </div>
        </div>
        </div> -->
        </div>
        </div>
       
        <div class="col-6" style="margin-left: auto;">
        <div class="d-flex align-items-center justify-content-end ">
       
        <!-- <a href="javascript:void(0);" (click)="productSearchClick()" class="widget-header mr-4 text-white">
        <div  (click)="productSearchClick()" class="icon d-flex align-items-center">
        <i  (click)="productSearchClick()" class="feather-search h6 mr-2 mb-0"></i>  <span>Search </span>
        </div>
        </a> -->
       
        <!-- <a href="offers.html" class="golden-btn widget-header mr-4 text-dark btn m-none">
        <div class="icon d-flex align-items-center">
        <i class="feather-disc h6 mr-2 mb-0"></i>  <span>Offers </span>
        </div>
        </a> -->
       
        <a  (click)="loginClick()" class="widget-header mr-4 text-white  cursor-pointer" *ngIf="!(+storeUserSettings.UserID)" >
        <div class="icon d-flex align-items-center">
        <i class="feather-user h6 mr-2 mb-0"></i>  <span>Sign in </span>
        </div>
        </a>
       
        <div class="dropdown mr-4 ">
        <a href="javascript:void(0);" class="dropdown-toggle text-white py-3 d-block" id="dropdownMenuButton" *ngIf="(+storeUserSettings.UserID)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
       
          




          <img *ngIf="(+storeUserSettings.UserID)" alt="#" src="{{storeSettings.apiCallingUrl+'Images/'}}{{storeUserSettings.ProfileImage}}" 
           onError="this.src='./assets/img/user2.png'" 
            class="img-fluid rounded-circle header-user mr-2 header-user"  style="height: 32px !important"/>
             <span class="m-none "> Hi {{getUser()}}</span>
        <!-- <img *ngIf="storeUserSettings.ProfileImage!=''" alt="#" src="{{storeSettings.apiCallingUrl+'Images/'}}{{storeUserSettings.ProfileImage}}" class="img-fluid rounded-circle header-user mr-2 header-user"/> Hi {{getUser()}} -->
        </a>
        <div class="dropdown-menu dropdown-menu-right"
         aria-labelledby="dropdownMenuButton" *ngIf="(+storeUserSettings.UserID)">
          <a class="dropdown-item" (click)="editProfile()">My account </a>
          <a class="dropdown-item" (click)="orders()">My Orders </a>

          <a class="dropdown-item" (click)="logoutClick()">Logout </a>
        
        </div>
        </div>
       
        <!-- <a (click)="cartClick()" class="widget-header mr-4 text-white">
        <div class="icon d-flex align-items-center">
        <i class="feather-shopping-cart h6 mr-2 mb-0 cursor-pointer"></i>  <span>Cart </span>
        </div>
        </a> -->
        <a class="toggle" href="javascript:void(0);">
        <span></span>
        </a>
        </div>
       
        </div>
       
        </div>
       
        </div>
       
        </section>
       
        </header>
<router-outlet></router-outlet>
<!-- <footer class="section-footer border-top bg-dark"   *ngIf="router.url !== '/login' && router.url !=='/registration'">
   
    <section class="footer-copyright border-top py-3 bg-light">
    <div class="container d-flex align-items-center">
    <p class="mb-0"> © 2021 Company ___ rights reserved  </p>
    <p class="text-muted mb-0 ml-auto d-flex align-items-center">
   
    </p>
    </div>
    </section>
    </footer>
     -->